import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useParams } from "react-router-dom";
import { Box, Typography, Breadcrumbs, Link, Paper,makeStyles,Divider } from '@material-ui/core';
import { Home as HomeIcon, NavigateNext as NavigateNextIcon } from '@material-ui/icons';
import { Link as RouterLink } from 'react-router-dom';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import DashboardIcon from "@material-ui/icons/Dashboard";
import PublishIcon from '@material-ui/icons/Publish';
import SettingsIcon from '@material-ui/icons/Settings';
const useStyles = makeStyles((theme) => ({
  root1: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  
}));
   
const Toolbar = ({ className, ...rest }) => {
  const classes = useStyles();
  var { auctionName } = useParams();
  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    > 
 
 <Box style={{ padding: '24px', backgroundColor: '#f4f4f4' }}>
      {/* Breadcrumb */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        style={{ marginBottom: 16 }}   
      >
        <Link
          color="textPrimary"
          component={RouterLink}
          to="/app/dashboard"
          style={{ display: 'flex', alignItems: 'center', color: '#333', fontWeight: 500 }}
        >
          <DashboardIcon fontSize="small" style={{ marginRight: 4 }} />
          Dashboard
        </Link>   
        <Link
          color="textPrimary"  
          // component={RouterLink}
          // to="/auctions"
          style={{ display: 'flex', alignItems: 'center', color: '#333', fontWeight: 500 }}
        >
          <SettingsIcon fontSize="small" style={{ marginRight: 4 }} />
          Setting
        </Link>
        {/* <Typography style={{ fontWeight: 600, color: '#000' }}>
          {auctionName}
        </Typography> */}
      </Breadcrumbs>

      {/* Header Card */}
      <Paper
        elevation={1}
        style={{
          padding: '20px 28px',
          borderRadius: 8,
          backgroundColor: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          border: '1px solid #e0e0e0',
        }}
      >
        <PublishIcon
          style={{
            fontSize: 40,
            color: '#000',
            marginRight: 20,
          }}
        />
        <Box>
          <Typography variant="h5" style={{ fontWeight: 'bold', color: '#000' }}>
            Upload Banner
          </Typography>
          <Typography variant="body2" style={{ color: '#555' }}>
          Details Overview
          </Typography>
        </Box>   
      </Paper>
    </Box>
      </div>
           
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
 